import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { OutputFormatEnum } from '../../ai/IAiService'
import type { IAction } from '../../action/IAction'

export interface IGenerateProductDescriptionByAi extends IAction<string, GenerateProductDescriptionByAiArgs> {}

@InputType()
export class GenerateProductDescriptionByAiArgs extends ActionArgs {
  @Field(() => ID)
  productId: string

  @Field(() => String, { nullable: true })
  outputFormat?: OutputFormatEnum
}
